import { useCallback } from 'react'

import { useSuspenseQuery } from '@tanstack/react-query'
import { useParams, useRouter } from '@tanstack/react-router'

import { type JudicialRecordViewProps } from '@/components/templates/JudicialRecordView/JudicialRecordView'
import { judicialRecordQuery } from '@/state/judicial/judicialRecords'

export const useJudicialRecordPage = (): JudicialRecordViewProps => {
  const { recordId } = useParams({ from: '/judicial/$recordId' })
  const router = useRouter()
  const { data } = useSuspenseQuery(judicialRecordQuery(recordId))

  const onBackToPiloteClicked = useCallback(() => {
    router.history.back()
  }, [router])

  return {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    record: data.data!,
    onBackToPiloteClicked,
  }
}
